seedWebApp.controller('MaterialSkusController', ['$scope', 'MaterialService',
    function ($scope, MaterialService) {

        $scope.prefs = {
            name: 'MaterialsGrid',
            sortByCol: null,
            canAdd: false,
            canEdit: true,
            canDelete: false
        };

        $scope.qtStockClass = function (item) {
            return 'qt-stocks';
        };

        $scope.materialTypeClass = function (item) {
            if (item == 'CADASTRAR') {
                return 'material-type-to-insert';
            }
        };

        $scope.columns = [
            { name: 'SkuName', display: 'SKU', filterOptions: [], limitTo: '35', width: 5, customClass: $scope.materialTypeClass, id:'SkuID' },
            //{ name: 'MaterialID', display: 'Item', customClass: function () { return 'agp-color'; }, filterOptions: [], width: 10, isKey: true },            
            { name: 'MaterialName', display: 'Material', filterOptions: [], limitTo: '35', width: 15, id: 'MaterialID' },
            { name: 'ContactName', display: $scope.translation.Client, id: 'ContactID', filterOptions: [], width: 10 },
            
            { name: 'SkuThickness', display: 'Espessura', filterOptions: [], width: 5 },
            { name: 'SkuWidth', display: 'Largura', filterOptions: [], width: 5 },
            { name: 'SkuLength', display: 'Comprimento', filterOptions: [], width: 5 },

            { name: 'ReferName', display: 'Refer', filterOptions: [], limitTo: '35', width: 5, id: 'ReferID' },
            { name: 'DrawingID', display: 'Desenho', filterOptions: [], width: 5 },

            //{ name: 'Stocks', display: 'Estoques', columnType: 'StockAndPO', dataType: 'StockAndPO', width: 10, customClass: $scope.qtStockClass }, //filterOptions: [], 
            //{ name: 'AltMaterial01', columnType: 'StockAndPO', dataType: 'StockAndPO', display: 'Substituto 01', width: 15 },
            //{ name: 'AltMaterial02', columnType: 'StockAndPO', dataType: 'StockAndPO', display: 'Substituto 02', width: 15 },
            //{ name: 'AltMaterial03', columnType: 'StockAndPO', dataType: 'StockAndPO', display: 'Substituto 03', width: 15 }
        ];

        $scope.insertNew = function () {
            MaterialService.openMaterialModal();
        }

        $scope.prefs.customEdit = function (item) {
            MaterialService.openMaterialModal(item.MaterialID);
        };

        $scope.loadColumns = MaterialService.getMaterialsColumns;
        $scope.loadService = MaterialService.getMaterialSkus;
        $scope.resetService = MaterialService.resetCache;

        $scope.getTotal = function () {
            $scope.loadingTotal = true;
            MaterialService.getMaterialSkusCount().then(function (response) {
                $scope.loadingTotal = false;
                $scope.totalItems = response.data;
            });
        };

        $scope.getTotal();

        $scope.searchMode = function () {
            $scope.$broadcast('inputSearch', $scope.filterString);
        };

        $scope.doRefresh = function () {
            $scope.$broadcast('refreshServiceGrid');
        };

        $scope.toExcel = function () {
            $scope.$broadcast('toExcel', 'materialSKUs');
        };

    }]);
